// extracted by mini-css-extract-plugin
module.exports = {"block":"Dropdown_block__3vsEi"};